import { NavLink } from "react-router-dom";

interface IBannerProps {
  isConnect?: boolean,
  showBtnHome?: boolean
}

function Banner(props: IBannerProps) {
  const { isConnect, showBtnHome } = props;

  return (
    <>
      {
        !isConnect &&
        <div id="banner" className="flex justify-center bg-yellowCustom h-20 relative rounded-lg">

          <img
            src="/logo-cemade.png"
            alt="le nom cemade formant un cercle de couleur orange"
            className="w-[100px] h-auto" // Empêche l'étirement horizontal
          />

          {
            showBtnHome &&
            <NavLink to="/" className="absolute right-[2%] bottom-[25%] bg-greenCustom text-white rounded-md font-medium hover:bg-orangeCustom transition-colors px-6 py-2"
              aria-label="Retour à l'accueil">
              Accueil
            </NavLink>
          }
        </div>
      }
    </>
  )
}
export default Banner;